import Api from './Api';

const all = (payload) => {
    const path = '/allowed-links';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const checkLink = (payload) => {
    return Api.postRequest({
        endpoint: '/allowed-link/get',
        data: payload
    });
}

const update = (payload) => {
    return Api.postRequest({
        endpoint: '/allowed-link/update',
        method: 'PUT',
        data: payload
    });
};

export default {
    all,
    checkLink,
    update
};
